import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Button} from 'react-bootstrap';
import { BiRefresh } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';


const Diagnosis = () => {
    const [listDiagnosis, setlistDiagnosis] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadInit = async () => {
        setIsLoading(true)
        try {
            const promise2 = await VedikaService.getDiagnosis2(`noregistrasifk=${$('#noRegistrasi').text()}`)
            const allPromise = await Promise.all([promise2]);
            if(allPromise[0].data.data.length==0){
                throw new Error('Maaf, Tidak ada data');
            }
            setlistDiagnosis(allPromise[0].data.data)
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        }finally{
            setIsLoading(false)
        }
    }

    const loadDtDiagnosis = () => {
        $('#dtDiagnosis').DataTable({
            data: listDiagnosis,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            autoWidth: false,
            paging:false,
            destroy:true,
            columns: [
                {
                    targets: [0],
                    data: 'tglinputdiagnosa',
                },
                {
                    targets: [1],
                    data: 'diagnosaawal',
                },
                {
                    targets: [2],
                    data: 'diagnosauatama',
                },
                {
                    targets: [3],
                    data: 'diagnosasekunder',
                },
                {
                    targets: [4],
                    data: 'prosedurtindakan',
                },
                {
                    targets: [5],
                    data: 'keterangan',
                },
            ]
        })
    }
    const loadDticd10 = (res) => {
        $('#dticd10').DataTable({
            data: res,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            // scrollY: '50vh',
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: 'jenisdiagnosa',
                    // createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup>),
                },
                {
                    targets: [1],
                    data: 'kddiagnosa',
                },
                {
                    targets: [2],
                    data: 'namadiagnosa',
                },
                {
                    targets: [3],
                    data: 'keterangan',
                },
                {
                    targets: [4],
                    data: 'namaruangan',
                },
                {
                    targets: [5],
                    data: 'namalengkap',
                },
                {
                    targets: [6],
                    data: 'tglinputdiagnosa',
                },
            ]
        })
    }
    const loadDticd9 = (res) => {
        $('#dticd9').DataTable({
            data: res,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            // scrollY: '50vh',
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: 'kddiagnosatindakan',
                },
                {
                    targets: [1],
                    data: 'namadiagnosatindakan',
                },
                {
                    targets: [2],
                    data: 'keterangantindakan',
                },
                {
                    targets: [3],
                    data: 'namaruangan',
                },
                {
                    targets: [4],
                    data: 'namalengkap',
                },
                {
                    targets: [5],
                    data: 'tglinputdiagnosa',
                },
            ]
        })
    }

    useEffect(()=>{
        loadDtDiagnosis();
    },[listDiagnosis])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])
    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Diagnosis</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    {/* <Tabs
                        defaultActiveKey="icd10"
                        id="uncontrolled-tab-example"
                        fill
                    >
                         <Tab eventKey="icd10" title="DIAGNOSIS ICD 10"> */}
                            {/* <Table responsive="sm" size="sm" id='dticd10' bordered hover style={{ fontSize: 'smaller' }}>
                                <thead>
                                    <tr>
                                        <th>Jenis Diagnosis</th>
                                        <th>Kode ICD 10</th>
                                        <th>Nama ICD 10</th>
                                        <th>Keterangan</th>
                                        <th>Ruangan</th>
                                        <th>Penginput</th>
                                        <th>Tgl Input</th>
                                    </tr>
                                </thead>
                            </Table> */}
                            <Table responsive="sm" size="sm" id='dtDiagnosis' bordered hover style={{ fontSize: 'smaller' }}>
                                <thead>
                                    <tr>
                                        <th>Tgl. Input</th>
                                        <th>Diagnosa Awal</th>
                                        <th>Diagnosa Utama</th>
                                        <th>Diagnosa Sekunder</th>
                                        <th>Prosedur Tindakan</th>
                                        <th>Keterangan</th>
                                    </tr>
                                </thead>
                            </Table>
                        {/* </Tab>
                        <Tab eventKey="icd9" title="DIAGNOSIS ICD 9">
                            <Table responsive="sm" size="sm" id='dticd9' bordered hover style={{ fontSize: 'smaller' }}>
                                <thead>
                                    <tr>
                                        <th>Kode ICD 9</th>
                                        <th>Nama ICD 9</th>
                                        <th>Keterangan</th>
                                        <th>Ruangan</th>
                                        <th>Penginput</th>
                                        <th>Tgl Input</th>
                                    </tr>
                                </thead>
                            </Table>
                        </Tab>
                    </Tabs> */}
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default Diagnosis;